export default function SceneCard({ name, pinyin, tone }) {
  return (
    <article className={`scene-card tone-${tone}`}>
      <div className="scene-art" aria-hidden="true">
        <span className="art-shape a" />
        <span className="art-shape b" />
        <span className="art-shape c" />
      </div>
      <div className="scene-overlay" />
      <div className="scene-bar">
        <span className="scene-pinyin">{pinyin}</span>
        <span className="scene-name">
          <i />
          {name}
        </span>
      </div>
    </article>
  );
}
